export default (state = [], payload) => {
  switch (payload.type) {
    case "NEW_NOTIFICATION":
      return [...state, payload.data];

    default:
      return state;
  }
};
